/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ICardFieldProps } from "../cards/CardField" 
import { SpeechBubble } from "../../primitive"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { defaultPrimitive, ILandingPrimitive, SPEECH_NOSE_HEIGHT } from "src/modules/pe-landing-module/data/interfaces"
import Primitive from "../../section/Primitive"

const CardFieldSpeechBubble = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props 
    const [bg]              = useState<string>( field.bg || value?.data.bg || "var(--force-plain-color)" )
    const [stroke]          = useState<string>( field.color || value?.data.color || "var(--force-contrast-color)" )
    const [strokeWidth]     = useState<number>( field.strokeWidth || value?.data.strokeWidth || 1 )
    const [tailWidth]       = useState<number>( field.tailWidth || value?.data.tailWidth || SPEECH_NOSE_HEIGHT )
    const [tailHeight]      = useState<number>( field.tailHeight || value?.data.tailHeight || SPEECH_NOSE_HEIGHT )
    const [tailPositionX]   = useState<number>( field.tailPositionX || value?.data.tailPositionX || 90 )
    const [tailPositionY]   = useState<number>( (field.tailHeight || value?.data.tailHeight || SPEECH_NOSE_HEIGHT) - 4 )
    const [width, setWidth]     = useState<number>( field.width || "100%" )
    const [height, setHeight]   = useState<number>( field.height || 90 )
    useEffect(() => { 
        addCSSClass(
            `landing-card-field-speech-bubble-${section.id + "-" + value?.id}`,
            `.landing-card-field-speech-bubble-${section.id + "-" + value?.id} {
            }
            .primitive-outer-${ (primitive.data?.id || "").toString() + "-" + props.i } {
                display: flex;
                align-items: center;
                transform: translateY(-${SPEECH_NOSE_HEIGHT / 2}px);
            }
            .speech-bubble-${section.id + "-" + value?.id} {
                background-color: ${ bg };
                border: ${ getCssDemention(strokeWidth) } solid ${ stroke };
            }`
        )
        setWidth(  document.querySelector( `.landing-card-field-speech-bubble-${ section.id + "-" + value.id }` )!.clientWidth )
        setHeight( document.querySelector( `.landing-card-field-speech-bubble-${ section.id + "-" + value.id } .pe-primitive-container`)?.clientHeight || height )  

        return () => { 
            removeCSSClass( `landing-card-field-speech-bubble-${ section.id + "-" + value?.id }` )
        }
    }, [value, field])
       
    const primitive: ILandingPrimitive = {
        ...defaultPrimitive(),
        ...field,
        ...value, 
        data: {...field.data, ...value.data},
        style: { 
            ...field.style, 
            ...value.style 
        },
        position: {
            ...field.position,
            width,
            height
        },
        id: section.id + "-" + value?.id,
    }

    return <div 
        className={`landing-card-field landing-card-field-speech-bubble landing-card-field-speech-bubble-${section.id + "-" + value.id} ${value.className || ""}`}  
        data-card-field-id={i} 
        card-field-section-id={section.id}
    >  
        {
            !!width || true
                ?
                <SpeechBubble 
                    primitive={primitive as any}
                >
                    <Primitive
                        primitive={{ ...primitive, ...field.data, ...value.data, isInline: true }}
                    />
                </SpeechBubble>
            :
            <></>
        }
    </div>
}
export default CardFieldSpeechBubble